import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { useTranslation } from 'react-i18next';

import { ErrorBoundary } from '@sentry/react';
import { createFileRoute } from '@tanstack/react-router';
import { Calendar } from '~/components/common/calendar/calendar';
import { withAuthorizationRequired } from '~/libs/auth';
import { AppLoader } from '~/routes/_auth';
import { titleWrapper } from '~/utils/title';
import { calendarQueryParamsSchema } from '~/validators/calendar-validator';

export const CALENDAR_SCOPES = [
  'scope.meusnidus.calendar.view',
  'scope.meusnidus.calendar.write',
];

export const Route = createFileRoute('/_auth/calendar/')({
  component: withAuthorizationRequired(RouteComponent, {
    onRedirecting: AppLoader,
    requireScope: CALENDAR_SCOPES,
  }),
  validateSearch: (search) => calendarQueryParamsSchema.parse(search),
});

function RouteComponent() {
  const { t } = useTranslation();

  return (
    <ErrorBoundary
      fallback={
        <div className="flex size-full items-center justify-center">
          {t('calendar.error')}
        </div>
      }
    >
      <title>{titleWrapper(t('calendar.url_title'))}</title>
      <DndProvider backend={HTML5Backend}>
        <Calendar />
      </DndProvider>
    </ErrorBoundary>
  );
}
